<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini" style="width: 100%;">
					<el-divider content-position="left">基本信息</el-divider>
					<el-row>
						<el-col :span="6">
							<el-form-item label="供应商名称" style="width: 100%;">
								<el-input v-model="form.suppliername" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="是否含税" style="width: 100%;">
								<emun name="enable" v-model="form.havetax" disabled />
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="待结算金额" style="width: 100%;">
								<el-input v-model="form.sum" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="备注" style="width: 100%;">
								<el-input v-model="form.mark"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-divider content-position="left">结算信息</el-divider>
					<el-row>
						<el-col :span="6">
							<el-form-item label="入库金额" style="width: 100%;">
								<el-input v-model="form.inamount" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">					
							<el-form-item label="退货金额" style="width: 100%;">
								<el-input v-model="form.outamount" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="总金额" style="width: 100%;">
								<el-input v-model="form.amount" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="供应商金额" style="width: 100%;">
								<el-input v-model="form.supplieramount" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="优惠金额" style="width: 100%;">
								<inputNumber size="mini" :precision="2" v-model="form.discount" @change="discountChange" />
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="优惠后金额" style="width: 100%;">
								<el-input v-model="form.discountamount" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<vxe-grid style="margin-top: 10px;" ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="success" content="保存" @click="save"></vxe-button>
			</template>
		</vxe-modal>
		<receipt v-if="receiptparam" ref="receipt" :param="receiptparam" />
	</div>
</template>
<style scoped>
	.img_block {
		position: relative;
		margin-top: 20px;
		width: 50%;
		height: 300px;
		display: inline-block;
		box-sizing: border-box;
		padding: 10px;
		box-sizing: border-box;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import receipt from '@/views/main/paymentout/paymentapplication/lib/receipt/index.vue'
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	import inputNumber from '@_system/components/formcomponents/common/inputNumber/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			currentrow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				list_autorender: false,
				modal_title: '对账',
				modal_width: 1600,
				modal_height: 800,
				list_footerField: [{
					field: 'size',
					toFixed: 0
				},{
					field: 'supplieramount',
					toFixed: 2
				}, {
					field: 'sum',
					toFixed: 2
				}, {
					field: 'cdsum',
					toFixed: 2
				}, {
					field: 'diff',
					toFixed: 2
				}],
				orderdata: [],
				columns: [],
				toolbarButton: [],
				file_path: [],
				receipt_path: [],
				receiptparam: null,
				row: null,
				form:{
					suppliername:null,
					havetax:null,
					settlementtime:null,
					inamount:null,
					outamount:null,
					amount:null,
					supplieramount:null,
					discount:0,
					discountamount:null,
					mark:null
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.file_path = []
				this.receipt_path = []
				this.row = this.currentrow
				let list_columns = [{
					type:'checkbox',
					title: '',
					width:40
				},{
					type:'seq',
					title: '#',
					width:40
				},{
					field: 'bizTime',
					title: '业务时间',
					width:100,
					slots: {
						default: ({
							row
						}) => {
							return window.systemMethods.timestampToDate(row.bizTime,true)
						},
					}
				},  {
					field: 'billType',
					title: '单据类型',
				},{
					field: 'proofbillcode',
					title: '结算单编码',
					width:120
				}, {
					field: 'stockCode',
					title: '入库单编号',
					width:120
				}, {
					field: 'billCode',
					title: '采购订单编号',
					width:120
				}, {
					field: 'storageName',
					title: '仓库'
				}, {
					field: 'goodsName',
					title: '产品名称'
				}, {
					field: 'skuName',
					title: '规格'
				}, {
					field: 'unitName',
					title: '单位'
				}, {
					field: 'price',
					title: '单价'
				}, {
					field: 'size',
					title: '数量'
				},{
					field: 'sum',
					title: '金额'
				},{
					field: 'supplieramount',
					title: '供应商金额',
					width:150,
					editRender:{
						name:'$inputNumber',
						props:{
							precision:2
						},
						events:{
							change:({column})=>{
								this.tablefieldChange(column.field)
							}
						}
					}
				},{
					field: 'diff',
					title: '差额'
				},{
					field: 'file_path',
					title: '凭证',
					slots: {
						default: ({
							row
						}) => {
							let ele = []
							let srcList = []
							if(row.file_path){
								row.file_path.forEach((item)=>{
									srcList.push(item.path)
									ele.push(<el-image style="width: 30px; height: 30px"src={item.path} preview-src-list={srcList}></el-image>)
								})
							}
							return ele
						},
					}
				},{
					field: 'mark',
					title: '备注'
				},{
					field: 'status',
					title: '状态',
					slots: {
						default: ({
							row
						}) => {
							if(row.status==0){
								return '未核对'
							}
							if(row.status==1){
								return '已核对'
							}
							return row.status
						},
					}
				},
				{
					title: '操作',
					width:100,
					fixed: "right",
					align: 'center',
					slots: {
						default: ({
							row
						}) => {
							return [
								<el-button type = "text" size = "mini" onClick={() => {this.reaudit(row)}} > 核对/撤销 </el-button>
							]
						},
					}
				},
				]
				let list_toolbarButton = [{
					code: 'reauditbatch',
					name: '批量核对/撤销',
					status: "success"
				},{
					code: 'rebuild',
					name: '重新生成对账单',
					status: "danger"
				},{
					code: 'export',
					name: '导出',
					status: "success"
				}]
				this.columns = list_columns
				this.toolbarButton = list_toolbarButton
				this.list_init()


			},
			tablefieldChange(){
				let data = this.$refs.orderdetail.getTableData().fullData
				data.forEach((item)=>{
					item.diff = parseFloat(item.supplieramount) - parseFloat(item.sum)
					item.diff = item.diff.toFixed(2)
				})
				this.computeAmount()
			},
			reaudit(row) {
				row.status = row.status == 1?0:1
				this.computeAmount()
			},
			reauditbatch(){
				let data = this.$refs.orderdetail.getCheckboxRecords()
				if(data.length!=0){
					data.forEach((item)=>{
						item.status = item.status == 1?0:1
					})
					this.computeAmount()
				}else{
					this.$message.error('请选择数据')
				}
			},
			rebuild(){
				this.$confirm('是否确认重新生成').then(()=>{
					this.$refs.orderdetail.commitProxy('query',{type:'rebuild'})
				})
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.cellStyle = this.cellStyle
				gridOptions.columns = this.columns
				gridOptions.toolbarConfig.buttons = this.toolbarButton
				gridOptions.proxyConfig.autoLoad = true
				gridOptions.height = 400
				gridOptions.formConfig = false
				gridOptions.scrollY = {
					enabled: false
				}
			},
			cellStyle({
				row,column
			}){
				let obj = {}
				if(column.property=='status'){
					if (row.status==0) {
						obj.color = '#F56C6C'
					}
					if (row.status==1) {
						obj.color = '#67C23A'
					}	
				}
				if (column.property=='diff') {
					if(row.diff<0){
						obj.color = '#67C23A'
					}else if(row.diff>0){
						obj.color = '#F56C6C'
					}
				}
				return obj
			},
			save() {
				let tabledata = this.$refs.orderdetail.getRecordset()
				this.form.itemnum = this.$refs.orderdetail.getTableData().fullData.length
				this.$api.reconciliationbill.saveBill(this.currentrow.id,{tabledata:tabledata,form:this.form}).then(()=>{
					this.$emit('success')
					this.modal_cancel()
					this.$message.success('操作成功')
				})
			},
			list(page, updateForm, other) {
				return new Promise((resolve) => {
					this.$api.reconciliationbill.createBill(this.currentrow.id,other).then((res) => {
						this.form = res.form
						resolve({
							list: res.table
						})
						this.$nextTick(()=>{
							this.computeAmount(res.table)
						})
					},()=>{
						this.$refs.orderdetail.reloadData()
					})
				})
			},
			discountChange(){
				this.computeAmount()
			},
			computeAmount(data=null){
				let tabledata = data
				if(!tabledata){
					tabledata =  this.$refs.orderdetail.getTableData().fullData
				}
				let inamount = 0
				let outamount = 0
				let amount = 0
				let supplieramount = 0
				let discountamount = 0
				tabledata.forEach((item)=>{
					if(item.status==1){
						if(item.billType=='采购入库单'){
							inamount += parseFloat(item.sum)
						}else{
							outamount += parseFloat(item.sum)
						}
						supplieramount += parseFloat(item.supplieramount)
					}
				})
				amount = inamount + outamount
				discountamount = supplieramount - this.form.discount
				
				let obj = {}
				obj.inamount = inamount.toFixed(2)
				obj.outamount = outamount.toFixed(2)
				obj.amount = amount.toFixed(2)
				obj.supplieramount = supplieramount.toFixed(2)
				obj.discountamount = discountamount.toFixed(2)
				this.form = {...this.form,...obj}	
			},
			submit() {
				this.$refs.orderdetail.remove(this.row)
			}
		},
		components: {
			receipt,
			emun,
			inputNumber,
		}
	}
</script>